"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateQueryParams = exports.multipleKeysArray = exports.commaSeparatedArray = void 0;
function commaSeparatedArray(paramKey, arrayParamValue) {
    return "".concat(paramKey, "=").concat(arrayParamValue.map(function (val) { return encodeURIComponent(val); }).join());
}
exports.commaSeparatedArray = commaSeparatedArray;
function multipleKeysArray(paramKey, arrayParamValue) {
    var returnValue = arrayParamValue.reduce(function (str, paramValue, index) {
        if (typeof paramValue !== 'undefined') {
            str += "".concat(index ? '&' : '').concat(paramKey, "=").concat(encodeURIComponent(paramValue));
        }
        return str;
    }, '');
    // TS really seems to thing returnValue can be string | number | boolean
    return returnValue;
}
exports.multipleKeysArray = multipleKeysArray;
function generateQueryParams(paramsObject, arrayReducer) {
    return Object.entries(paramsObject).reduce(function (str, _a, index) {
        var paramKey = _a[0], paramValue = _a[1];
        try {
            str += "".concat(index ? '&' : '?').concat(Array.isArray(paramValue) ? '' : "".concat(paramKey, "=")).concat(typeof paramValue === 'string' ?
                encodeURIComponent(paramValue) :
                (typeof paramValue === 'number' ||
                    typeof paramValue === 'boolean') ?
                    paramValue :
                    Array.isArray(paramValue) ?
                        arrayReducer(paramKey, paramValue) :
                        '');
        }
        catch (e) {
            console.log('Made a mistake:', e.message);
        }
        return str;
    }, '');
}
exports.generateQueryParams = generateQueryParams;
